import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-white/5 pt-24 pb-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 mb-24">
          <div className="lg:col-span-2">
            <a href="/" className="text-3xl font-black tracking-tighter uppercase mb-8 block">
              Pixel<span className="text-fuchsia-500">Petals</span>
            </a>
            <p className="text-zinc-500 text-sm leading-relaxed max-w-sm mb-10">
              A creative workspace for mobile hardware aesthetic. Engineering protection for the next generation of digital pioneers.
            </p>
            <div className="flex gap-6">
              {['Instagram', 'Twitter', 'TikTok'].map(platform => (
                <a key={platform} href="#" className="text-[10px] font-black uppercase tracking-widest text-zinc-400 hover:text-cyan-400 transition-colors">
                  {platform}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-white font-black uppercase tracking-[0.3em] text-[10px] mb-8">Navigation</h4>
            <ul className="space-y-4 text-xs font-bold text-zinc-500 uppercase tracking-widest">
              <li><a href="#drop" className="hover:text-white transition-colors">The Drop</a></li>
              <li><a href="#bundles" className="hover:text-white transition-colors">Bundles</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Archive</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Lab Reports</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-black uppercase tracking-[0.3em] text-[10px] mb-8">Support</h4>
            <ul className="space-y-4 text-xs font-bold text-zinc-500 uppercase tracking-widest">
              <li><a href="#" className="hover:text-white transition-colors">Shipping</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Returns</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Contact</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Privacy</a></li>
            </ul>
          </div>
        </div>

        <div className="pt-12 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-[10px] font-black uppercase tracking-[0.4em] text-zinc-600">
            © {new Date().getFullYear()} PIXELPETALS STUDIO
          </p>
          <div className="flex items-center gap-8">
             <div className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-cyan-400" />
                <span className="text-[9px] font-black uppercase tracking-widest text-zinc-400">Node_v1.0.4_Live</span>
             </div>
             <p className="text-[9px] font-black uppercase tracking-widest text-zinc-600">Encrypted Transaction Protocol</p>
          </div>
        </div>
      </div>
      <div className="px-8 pb-6 text-center">
        <p style={{ textTransform: 'none' }}><span>Made by </span><a href="https://diglab.ai/" target="_blank" rel="noopener noreferrer" style={{ textTransform: 'none' }}>DigLab.ai</a><span> and </span><a href="https://linglinkai.cn/" target="_blank" rel="noopener noreferrer" style={{ textTransform: 'none' }}>LingLinkAI.cn</a></p>
      </div>
    </footer>
  );
};

export default Footer;